import { useCountdown } from "@shared/src/utils/helpers/countdown";
import { cn } from "@shared/src/utils/cn";

interface CountdownTimerProps {
  targetDate: Date;
  label?: string;
  onComplete?: () => void;
  className?: string;
  labelClassName?: string;
  timerClassName?: string;
}

export function CountdownTimer({
  targetDate,
  label,
  onComplete,
  className,
  labelClassName,
  timerClassName,
}: CountdownTimerProps) {
  const { formattedTime } = useCountdown({ targetDate, onComplete });

  return (
    <div className={cn("flex items-center gap-2", className)}>
      {label && <span className={cn("text-text-tertiary text-small-2", labelClassName)}>{label}</span>}
      <span className={cn("font-extrabold text-text-primary text-small-2", timerClassName)}>{formattedTime}</span>
    </div>
  );
}
